import { ImageTypes } from '../../../types/api/ImageType';
import { MediaInformationModifier } from './MediaInformation.modifier';
import { MediaSize } from './Constants';
import layoutVariations from '../../blocks/LayoutGroup/layoutVariations';
import { Media } from './MediaInformation';

type LayoutVariation = '' | 'float-right' | 'float-left' | 'two-columns';

export function useMediaInformation() {
  const getModifier = (
    media: Media,
    layoutVariation: LayoutVariation,
    hasPopUpParam: boolean | undefined,
    sliderParam: boolean | undefined,
    isImageInPopUpSlider?: boolean,
  ) => {
    const modifier = [];

    // padding on contentImages && iframes
    if (
      (media.imageType && media.imageType === ImageTypes.contentImage) ||
      (!media.imageType && media.contentType === 'iframe')
    ) {
      modifier.push(`${MediaInformationModifier.PADDING}`);
    }

    // different modifier for different sizes
    if (media.size && media.size === MediaSize.medium) {
      modifier.push(`${MediaInformationModifier.MEDIUM}`);
    }

    if (media.size && media.size === MediaSize.small) {
      modifier.push(`${MediaInformationModifier.SMALL}`);
    }

    // no floats on large MediaSize
    if (layoutVariation && media.size !== MediaSize.large) {
      if (layoutVariation === layoutVariations.floatLeft) {
        modifier.push(`${MediaInformationModifier.FLOAT_LEFT}`);
      }

      if (layoutVariation === layoutVariations.floatRight) {
        modifier.push(`${MediaInformationModifier.FLOAT_RIGHT}`);
      }

      if (layoutVariation === layoutVariations.twoColumns) {
        modifier.push(`${MediaInformationModifier.TWO_COLUMNS}`);
      }
    }

    // different modifier for top headlines
    if (media.imageType && media.imageType === ImageTypes.topHeadlineImage) {
      modifier.push(`${MediaInformationModifier.TOP_HEADLINE_IMAGE}`);
    }

    if (media.imageType && media.imageType === ImageTypes.topHeadlineImageSmall) {
      modifier.push(`${MediaInformationModifier.TOP_HEADLINE_IMAGE_SMALL}`);
    }

    // image that has a popup modal dialog attached
    if (hasPopUpParam) {
      modifier.push(`${MediaInformationModifier.POP_UP}`);
    }

    // image as part of a slider
    if (sliderParam) {
      modifier.push(`${MediaInformationModifier.SLIDER}`);
    }

    // image as part of a slider in a popup
    if (isImageInPopUpSlider) {
      modifier.push(`${MediaInformationModifier.SLIDER_IN_POP_UP}`);
    }

    if (modifier.length > 0) {
      return modifier;
    }
    return null;
  };

  const hasPadding = (media: Media): boolean => {
    if (
      (media.imageType &&
        (media.imageType === ImageTypes.contentImage || media.imageType === ImageTypes.topHeadlineImageSmall)) ||
        (!media.imageType && media.contentType)
    ) {
      return false;
    }

    return true;
  };

  return {
    getModifier,
    hasPadding,
  };
}
